import axios from 'axios';
import getHeaders from './getHeaders';
import { HTTP_STATUS } from '../constants/httpsStatus/httpsStatus';

export const makeApiCall = async ({ method, endpoint, data = null, dispatch, requestType='', successType, failureType, params = {} }) => {
    const API_URL = process.env.REACT_APP_API_URL;
    const url = `${API_URL}${endpoint}`;

    const options = {
        method,
        headers: getHeaders(),
        url,
        params,
        ...(data && { data }),
    };

    dispatch({ type: requestType });

    try {
        const response = await axios(options);
        if (response.status === HTTP_STATUS.SUCCESS || response.status === HTTP_STATUS.CREATED) {
            dispatch({ type: successType, payload: response?.data });
            return { status: response?.status, message: response?.data?.message };
        } else {
            throw new Error('Invalid response status');
        }
    } catch (error) {
        const errorMessage = error?.response?.data?.error || error.message || 'An error occurred';
        dispatch({ type: failureType, payload: errorMessage });
        return { status: error?.response?.status || 500, message: errorMessage };
    }
};